export default __webpack_public_path__ + "static/media/Spike Shield.f8855646.jpg";